<template>
  <v-app>
    <LayoutDefault>
      <template slot="navbar.vertical">
        <NavbarVertical :new-lead-form-data="newLeadMenuTestData"/>
      </template>
      <template slot="navbar">
        <NavBar v-model="navbarModelValue" :items="navbarItems" @performSearch="onPerformSearch">
          <template v-slot:person.dropdown="{close}">
            <PersonDropdown :close="close" :data="personData" @edit="onEditProfile" @logout="onLogout"/>
          </template>
          <template slot="group.dropdown">
            <GroupDropdown class="test-max-height" v-model="groupDropdownModel" :users="users"/>
          </template>
        </NavBar>
      </template>
      <v-row class="mb-2">
        <router-link class="mx-1" to="/">Button view</router-link>
        <router-link class="mx-1" to="/icon-view">Icon view</router-link>
        <router-link class="mx-1" to="/information-view">Information view</router-link>
        <router-link class="mx-1" to="/card-view">Card view</router-link>
        <router-link class="mx-1" to="/login-view">Login view</router-link>
        <router-link class="mx-1" to="/register-view">Register view</router-link>
        <router-link class="mx-1" to="/verification-view">Verification view</router-link>
        <router-link class="mx-1" to="/completed-view">Completed view</router-link>
        <router-link class="mx-1" to="/collapsible-view">Collapsible view</router-link>
        <router-link class="mx-1" to="/lead-list-view">Lead list view</router-link>
        <router-link class="mx-1" to="/journal-view">Journal view</router-link>
        <router-link class="mx-1" to="/pipeline-view">Pipeline view</router-link>
        <router-link class="mx-1" to="/profile-view">Profile view</router-link>
        <router-link class="mx-1" to="/tabs-view">Tabs view</router-link>
        <router-link class="mx-1" to="/group-profile-view">Group profile view</router-link>
        <router-link class="mx-1" to="/assignment-view">Assignment view</router-link>
        <router-link class="mx-1" to="/marketplace-administration-view">Marketplace administration view</router-link>
        <router-link class="mx-1" to="/kpi-view">KPI view</router-link>
        <router-link class="mx-1" to="/top-list-view">Top list view</router-link>
        <router-link class="mx-1" to="/salesfunnel-view">SalesFunnel</router-link>
        <router-link class="mx-1" to="/markdown-editor-view">Markdown Editor</router-link>
      </v-row>
      <router-view/>
      <Toast/>
      <v-row>
        <v-col>
          {{ navbarModelValue }}
          <v-btn @click="setUnsetAvatar">Set / unset avatar</v-btn>
          Person data: {{personData}}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          {{users[groupDropdownModel]}}
        </v-col>
      </v-row>
    </LayoutDefault>

    <SideBar sideBarId="exampleSidebar1">
      <SideBarExample/>
    </SideBar>
    <SideBar sideBarId="exampleSidebar2">
      <div>Testüberschrift 2</div>
      <div>test 2</div>
    </SideBar>
  </v-app>
</template>
<script>

import {reactive, ref} from '@vue/composition-api'

import {provideLocalization} from './plugins/localization'
import de from './locales/de.json'
import en from './locales/en.json'

import LayoutDefault from './components/layout/LayoutDefault'
import {provideToastMessageQueue} from './components/toast/toast'
import Toast from './components/toast/Toast.vue'
import NavbarVertical from "@/components/layout/navigation/NavbarVertical";
import NavBar from "@/components/layout/navigation/Navbar";
import PersonDropdown from "@/components/layout/navigation/dropdown/PersonDropdown";
import GroupDropdown from "@/components/layout/navigation/dropdown/GroupDropdown";
import SideBar from "@/components/layout/SideBar";
import SideBarExample from "@/components/layout/SideBarExample";

export default {
  components: {
    SideBarExample,
    SideBar,
    GroupDropdown,
    PersonDropdown,
    NavBar,
    NavbarVertical,
    Toast,
    LayoutDefault
  },
  setup(_, {root}) {
    provideLocalization({
      de,
      en
    })
    provideToastMessageQueue()

    const navbarModelValue = reactive({
      searchString: ''
    })

    const navbarItems = reactive(
      [
        {
          icon: '$question',
          notification: true,
          onClick: () => root.$openSidebar('exampleSidebar1')
        },
        {
          icon: '$notification',
          notification: true
        },
        {
          icon: '$group',
          notification: false,
          dropdown: 'group.dropdown'
        },
        {
          icon: '$person',
          notification: false,
          dropdown: 'person.dropdown'
        }
      ]
    )

    const personData = reactive({
      id: 1,
      name: 'Thomas Drostendorf',
      email: 'thomas.drostendorf@mail.de',
      imageSrc: undefined
    })

    function setUnsetAvatar(){
      if (typeof personData.imageSrc === 'undefined') {
        personData.imageSrc = 'https://picsum.photos/46?random=1'
      } else {
        personData.imageSrc = undefined
      }
    }

    const users = [
      {
        id: 1,
        name: 'Andre 5204'
      },
      {
        id: 2,
        name: 'Omega Ultra',
        imageSrc: 'https://picsum.photos/32?random=2',
        active: true
      },
      {
        id: 3,
        name: 'OMAHA GMBH',
        imageSrc: 'https://picsum.photos/32?random=3'
      },
      {
        id: 4,
        name: 'Utah Concordia',
        imageSrc: 'https://picsum.photos/32?random=4'
      },
      {
        id: 5,
        name: 'Calmaris GmbH'
      },
      {
        id: 6,
        name: 'Andre 5204'
      },
      {
        id: 7,
        name: 'Omega Ultra',
        imageSrc: 'https://picsum.photos/32?random=5'
      },
      {
        id: 8,
        name: 'OMAHA GMBH'
      },
      {
        id: 9,
        name: 'Utah Concordia'
      },
      {
        id: 10,
        name: 'Calmaris GmbH'
      }
    ]

    const groupDropdownModel = ref(0)

    function onEditProfile(personData){
      console.log('edit:', personData)
    }

    function onLogout(personData){
      console.log('logout:', personData)
    }

    function onPerformSearch(searchTerm) {
      console.log(searchTerm);
    }

    const newLeadMenuTestData = reactive({
      'Meine Formulare': {
        'Formular 1': '/',
        'Formular 2': '/',
        'Formular 3': '/'
      },
      'Gruppen Formulare': {
        'Formular 1': '/',
        'Formular 2': '/',
        'Formular 3': '/'
      },
      'Marktplatz Formulare': {
        'Formular 1': '/',
        'Formular 2': '/',
        'Formular 3': '/'
      }
    })

    return {
      navbarModelValue,
      onPerformSearch,
      newLeadMenuTestData,
      navbarItems,
      personData,
      users,
      groupDropdownModel,
      setUnsetAvatar,
      onEditProfile,
      onLogout
    }
  }
}

</script>
<style lang="scss">
@import "scss/fonts";

html {
  height: 100%;
  min-height: 100%;
}

#app {
  background-image: url("assets/icons/background.svg");
  background-position: center center;
  background-repeat: no-repeat;
  min-width: 1200px;
  height: 100%;
  min-height: 680px;

  .home {
    padding: $spacer * 6 $spacer * 4 $spacer * 2 $spacer * 8;
    transition: padding .2s ease-in-out;
  }

  // Change padding if menu is open
  .navbar-vertical.show ~ #layout_default_content .home {
    padding-left: 250px + $spacer * 4;
  }

  .layout-wrapper {
    display: flex;
    height: 100%;
  }

  .notification {
    position: relative;

    &::after {
      background-color: #B833CC;
      border: 1px solid $white;
      border-radius: 50%;
      content: '';
      display: block;
      width: 11px;
      height: 11px;
    }
  }

  .text-h1 {
    color: #174136;
  }

  .text-h2 {
    color: #878787;
  }
}

.test-max-height {
  max-height: 300px;
}

.v-application p {
  margin-bottom: $spacer;
}

@import "scss/components/form";
@import "scss/components/buttons/button";
@import "scss/components/busy";
</style>
